<template>
  <div class="container">
    <FormGenerator :config_file="config_file"> </FormGenerator>
  </div>
</template>

<script>
import FormGenerator from "@/components/FormGenerator.vue";

export default {
  name: "DocsExamples",
  components: {
    FormGenerator
  },
  data() {
    return {
      config_file: "/forms_configuration/docsexamples/config.json"
    };
  }
};
</script>
